// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yfZR","fullView":"styles_fullView__1uX5e"};